import * as io from "io-ts";
import { literalUnion } from "diagnostics-lib/io";
function createIOSortType<Column extends string>(columns: readonly Column[]) {
  return io.strict({
    column: literalUnion(columns),
    direction: io.union([io.literal("asc"), io.literal("desc")]),
  });
}

export default createIOSortType;
